import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/features/auth/useAuth';
import { router } from '@/app/router';

/**
 * Raad dashboard root. Auth state (in-memory access token + silent bootstrap)
 * wraps the router so every route can read it; the router itself carries the
 * basename derived from the Vite base (now the origin root, `/`).
 */
export function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
